module.exports = __webpack_public_path__ + "static/media/md-pie.f47cb3cb.svg";